import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Stop extends Model {
  resource() {
    return 'admin/stops'
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }

  get placeList() {
    return this.places.map(function(obj) {
      return obj['id']
    })
  }
}
